const formatDate = (datestr) => {
  let d = new Date(datestr)

  return (d.getMonth()+1) + "-" + d.getDate() + "-" + d.getFullYear().toString().substring(2)
} 

const formatDateMY = (datestr) => {
  let d = new Date(datestr)
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  return months[d.getMonth()] + ' ' + d.getFullYear()
}

const timeFormatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' })

const formatTime = (datestr) => {
  const d = new Date(datestr)

  return timeFormatter.format(d)
} 

const rtf = new Intl.RelativeTimeFormat('en-US', { numeric: 'auto', style: 'short' });

const formatRelative = (datestr) => {
  if (!datestr)
    return ''

  let relative_seconds = Math.floor((new Date(datestr) - Date.now())/1000, 0)

  if (-relative_seconds < 120) {
    return rtf.format(relative_seconds, "seconds")
  }

  relative_seconds = Math.floor(relative_seconds / 60, 0)
  if (-relative_seconds < 60) {
    return rtf.format(relative_seconds, "minutes")
  }

  relative_seconds = Math.floor(relative_seconds / 60, 0)
  if (-relative_seconds < 48) {
    return rtf.format(relative_seconds, "hours")
  }

  relative_seconds = Math.floor(relative_seconds / 24, 0)
  return rtf.format(relative_seconds, "days")
}

const brandWord = (brand) => {
  switch(brand) {
    case 'visa': return 'Visa'
    case 'mastercard': return 'MasterCard'
    case 'amex': return 'American Express'
    case 'discover': return 'Discover'
    default: return 'Unknown'
  }
}

const formatCurrency = (currency_cents) => {
  return '$' + (currency_cents / 100.0).toFixed(2)
}

export default {
  brandWord,
  formatCurrency,
  formatDate,
  formatDateMY,
  formatRelative,
  formatTime,
}